
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aMfLn", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("8Mzkb", function(module, exports) {
/* CreateComment.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @graphql cc */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $bSvtO = parcelRequire("bSvtO");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $cAdj8 = parcelRequire("cAdj8");


var $kmHPt = parcelRequire("kmHPt");


var $daq5m = parcelRequire("daq5m");


var $isdzP = parcelRequire("isdzP");


var $6cWI7 = parcelRequire("6cWI7");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $9CnRS = parcelRequire("9CnRS");


var $aMfLn = parcelRequire("aMfLn");


var $9QIM2 = parcelRequire("9QIM2");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $k8e76 = parcelRequire("k8e76");


var $56QzY = parcelRequire("56QzY");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $en1dX = parcelRequire("en1dX");


var $5fMeR = parcelRequire("5fMeR");


var $6mKj3 = parcelRequire("6mKj3");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4c77c6e390a7914$export$d26c1daa0321174b = (0, $aJPUt.ExperienceTimeout).CREATE_COMMENT_PUBLISH;
const $f4c77c6e390a7914$var$relativeFilePath = 'annotation-provider-inline-comments/CreateComment';
const $f4c77c6e390a7914$var$i18n = (0, $cgtv4.defineMessages)({
    unableToApplyTitle: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.title",
        defaultMessage: "Something went wrong"
    },
    unableToApplyDescription: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.description",
        defaultMessage: "We failed to display your comment. To view it, refresh now."
    },
    refreshContentLink: {
        id: "annotation-provider-inline-comments.refresh.content.link",
        defaultMessage: "Refresh content"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c77c6e390a7914$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b",
            __cmplp.className
        ])
    });
});
const $f4c77c6e390a7914$var$getNodeType = (element, annotationId)=>{
    const nodeWithAnnotationWrapper = element.querySelector(`[id="${annotationId}"]`);
    if (nodeWithAnnotationWrapper) {
        const firsChildren = nodeWithAnnotationWrapper.firstChild;
        if (firsChildren?.nodeType === Node.TEXT_NODE) return 'text';
        const targetNode = nodeWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
    }
    return 'unknown';
}; // Exporting for testing cases
const $f4c77c6e390a7914$export$d4044f5b8f4bc73a = (setWasDraftAnnotationRemoved)=>(mutationList, observer)=>{
        for (const mutation of mutationList){
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length > 0) mutation.removedNodes.forEach((node)=>{
                    const nodeClassList = Array.from(node.classList ?? []); // COMMENTS-4308 - If any part of the draft annotation was removed, check if the entirity of the draft
                    // 				   was removed, if so, we need to disable the editor buttons as the comment will fail
                    if (nodeClassList.includes('ak-editor-annotation-draft')) {
                        if (document.querySelector('.ak-editor-annotation-draft') === null) {
                            // Tell the editor that the draft annotation was removed
                            setWasDraftAnnotationRemoved(true);
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog - draft annotation removed`); // Disconnect the observer since we no longer need it
                            observer.disconnect();
                        }
                    }
                });
            }
        }
    };
const $f4c77c6e390a7914$var$CreateCommentComponent = ({ pageId: pageId, annotationElement: annotationElement, selectionOptions: selectionOptions, onClose: onClose, onCreate: onCreate, isEditor: isEditor, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, flags: flags, isOffline: isOffline })=>{
    const started = (0, $42omo.useRef)(false);
    const pageClass = (0, $9QIM2.usePageClass)();
    if (started.current === false) {
        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.start();
        started.current = true;
    }
    const initialisedSelection = (0, $42omo.useRef)(false);
    if (selectionOptions && selectionOptions?.createdFrom === 'EDITOR' && initialisedSelection.current === false) {
        initialisedSelection.current = true;
        if (selectionOptions.inlineNodeTypes) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: selectionOptions.inlineNodeTypes
        });
    }
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const lastContentFetchTime = (0, $42omo.useRef)(1);
    const requestTimeoutHandle = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const draftAnnotationMutationObserverRef = (0, $42omo.useRef)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const { documentUpdated: documentUpdated, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [shouldRefetch, setShouldRefetch] = (0, $42omo.useState)(false);
    const [wasDraftAnnotationRemoved, setWasDraftAnnotationRemoved] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElement,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: Boolean(isEditor),
        annotationElement: annotationElement,
        windowWidth: windowWidth,
        isSticky: isSticky
    }); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [createCommentFn] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation CreateCommentInlineCommentMutation($input:CreateInlineCommentInput!$pageId:ID!$includeReactionsAndReplies:Boolean!){createInlineComment(input:$input){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactionsAndReplies){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}replies@include(if:$includeReactionsAndReplies){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`);
    const { createInlineCommentInterop: createInlineCommentInterop } = (0, $6cWI7.useCreateInlineCommentMutation)({
        contentId: pageId
    });
    const { pageInfo: pageInfo, loading: loading, error: error, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onError: (err)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: err
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        // should only refresh on the Content Out of date `Refresh` CTA is clicked
        if (documentUpdated && shouldRefetch && refetch) {
            refetch();
            setShouldRefetch(false);
            onClose && onClose();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentUpdated,
        shouldRefetch
    ]);
    (0, $42omo.useEffect)(()=>{
        const metadata = document.querySelector('meta[name=confluence-request-time]');
        if (metadata) {
            const fetchTime = Number(metadata.getAttribute('content'));
            lastContentFetchTime.current = isNaN(fetchTime) ? 1 : fetchTime;
        }
        if (pageMode !== (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            const editorTextArea = document.getElementById('ak-editor-textarea');
            draftAnnotationMutationObserverRef.current = new MutationObserver($f4c77c6e390a7914$export$d4044f5b8f4bc73a(setWasDraftAnnotationRemoved)); // We need to watch the whole editorTextArea because highlights could
            if (editorTextArea) draftAnnotationMutationObserverRef.current.observe(editorTextArea, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            if (pageMode !== (0, $cD1qu.PageMode).VIEW && draftAnnotationMutationObserverRef.current && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) draftAnnotationMutationObserverRef.current.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Check for highlight element on mount - fail experience if createComment renders without a highlight
    // This tracks the scenario where createComment re-renders on close of the comment box without a highlight
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_enable_exp_create_rerenderer', 'isEnabled', true)) return;
         // Use a small delay to allow the DOM to settle after any state changes
        const timeoutId = setTimeout(()=>{
            const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191(); // Fail experience if createComment renders without a highlight
            if (!draftAnnotationElement && !wasDraftAnnotationRemoved) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('CreateComment renders without highlight'));
        }, 100);
        return ()=>clearTimeout(timeoutId); // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedTracker = (0, $42omo.useRef)({
        lastMutationSucceeded: false,
        totalSaves: 0,
        failedSaves: 0
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const savesWithoutError = // hit, the experience will already have completed in the `handleSaveComment`.
            saveAttemptedTracker.current.totalSaves - saveAttemptedTracker.current.failedSaves;
            if (saveAttemptedTracker.current.failedSaves > 0) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                // eslint-disable-next-line react-hooks/exhaustive-deps
                failedSaves: saveAttemptedTracker.current.failedSaves
            });
            if (savesWithoutError > 1) {
                // At the point this is dismounting -- we don't know for certain if the user intended for this to be discarded or not
                // so we hard fail the full experience (it's possible the dismount is because the second save has worked and
                // the UI is about to load the new comment)
                (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                    savesWithoutError: savesWithoutError
                });
                const msg = 'User clicked save, but UI did not update following successful save'; // we log a debug point and continue with the flow, since creation is not necessarily failing
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debugPoint(msg);
            }
            if (saveAttemptedTracker.current.lastPublishFailure) {
                if (saveAttemptedTracker.current.lastMutationSucceeded) {
                    // in the case there was a publish failure, but the last mutation succeeded -- we assume the dismount is
                    // because the ui is about to load the new comment - in this case we only mark the experience as a soft
                    // failure (we'll capture more details and fail in the final experience step)
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.softFail(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                } else {
                    // In this scenario -- the user attempted to save at least once, got a network error, and gave up on
                    // trying to create the comment
                    // For a subset of errors -- the user is presented with a human readable error message describing that
                    // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
                    // that they need to refresh the page to apply the comment.  In this scenario we don't treat the comment
                    // creation as a failure, but rather we want to mark the experience as aborted.
                    const contentChangedErrorSubstrings = [
                        'Invalid arguments provided for matchIndex and/or numMatches',
                        'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                        'Selection was made against a stale version of the content',
                        'Published Version out of date. Please provide correct published version.'
                    ];
                    const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>// eslint-disable-next-line react-hooks/exhaustive-deps
                        saveAttemptedTracker.current.lastPublishFailure?.message.includes(substring));
                    if (isContentChangedError) {
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                            abortReason: 'Unable to apply annotation to document'
                        });
                        return;
                    } // This is handled in the UI appropriately, and we should abort not fail
                    const permissionErrorSubstring = 'Could not create content with type comment';
                    const isPermissionError = saveAttemptedTracker.current.lastPublishFailure?.message.includes(permissionErrorSubstring);
                    if (isPermissionError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                        abortReason: 'User does not have space permission to create comments'
                    });
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                }
            }
            if (saveAttemptedTracker.current.lastMutationSucceeded) {
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
                return;
            } // In this case the user did not attempt to save the comment, and so we assume this was
            // an intentional discard of the comment.
            // So we abort the draftToPublishExperience here, along with any unfinished initExperience.
            const abortReason = 'Create Comment UI dismissed';
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                abortReason: abortReason
            });
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                abortReason: abortReason
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
        };
    }, []);
    const saveAttemptedCounts = (0, $42omo.useRef)({
        total: 0,
        failedSaves: 0
    });
    const failPublishExperience = (0, $42omo.useCallback)((commentPublishError, translatedErrorMsg)=>{
        // COMMENTS-1879 - Only log unexpected errors or annotation application error as failures
        if ((0, $isdzP.isUnexpectedError)(translatedErrorMsg)) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: commentPublishError
        });
        else (0, $7Sm4c.markErrorAsHandled)(commentPublishError);
    }, [
        experienceTracker
    ]);
    const onCacheUpdateError = (0, $42omo.useCallback)((cacheError)=>{
        const { message: message } = (0, $isdzP.parseError)(cacheError);
        failPublishExperience(cacheError, (0, $isdzP.getTranslatedError)(message));
    }, [
        failPublishExperience
    ]);
    const handleSaveCommentWithTimeout = (timeoutInMs, saveMutation)=>{
        const timeout = new Promise((_resolve, reject)=>{
            requestTimeoutHandle.current = setTimeout(()=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    error: new Error(`Request took longer than ${timeoutInMs}ms`)
                });
                return reject({
                    error: (0, $9CnRS.i18n).createTimeout
                });
            }, timeoutInMs);
        });
        return Promise.race([
            timeout,
            saveMutation
        ]).finally(()=>{
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
        });
    };
    const handleSaveComment = (adf, onSuccess)=>{
        saveAttemptedTracker.current.totalSaves = saveAttemptedTracker.current.totalSaves + 1;
        saveAttemptedTracker.current.lastMutationSucceeded = false;
        saveAttemptedCounts.current.total = saveAttemptedCounts.current.total + 1;
        if (!selectionOptions) // We likely will never get here, but just in case
        return Promise.reject({
            error: (0, $9CnRS.i18n).unableToGenerateStep
        });
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
            attributes: {
                pageId: pageId,
                pageMode: pageMode,
                isEditor: isEditor
            }
        });
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).start();
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationStart');
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                timeout: $f4c77c6e390a7914$export$d26c1daa0321174b
            }
        });
        const { numMatches: numMatches, matchIndex: matchIndex, originalSelection: originalSelection, createdFrom: createdFrom, step: step, targetNodeType: targetNodeType } = selectionOptions; // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                numMatches: numMatches,
                matchIndex: matchIndex,
                originalSelection: originalSelection,
                createdFrom: createdFrom,
                lastFetchTimeMillis: lastContentFetchTime.current,
                publishedVersion: publishedDocumentVersion,
                ...!!step && {
                    step: (0, $aMfLn.constructStepForGql)(step)
                }
            },
            pageId: pageId,
            includeReactionsAndReplies: false
        }; // Note -- this mixes data saving logic and UI application logic.
        // And when the UI logic fails, the result is that the user is left with
        // the ui looking like the comment failed to save.
        // This should be refactored to separate the two concerns, and on a UI application
        // failure, we should encourage users to refresh (and mark the experience as failed).
        let succeededPublish = false;
        const onCreateSuccess = (retVal)=>{
            saveAttemptedTracker.current.lastMutationSucceeded = true;
            const { data: data } = retVal;
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
            succeededPublish = true;
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.publishSucceeded(); // Mark comment creation end for both cohorts
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationEnd');
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            const annotationId = data?.createInlineComment?.location?.inlineMarkerRef;
            const commentId = data?.createInlineComment?.id;
            if (!annotationId || !commentId) throw new Error(`Comment was not saved correctly - either annotationId '${annotationId}' or commentId '${commentId}' were undefined`);
             // Reset the content changing flag
            resetContentChanged(); // Grab the marker ref id returned and update the editor/renderer
            try {
                onCreate(annotationId, data?.createInlineComment);
            } catch (e) {
                // We generate errors in renderer, but this will also handle the editor case
                throw new Error(`Unable to apply annotation to document - ${e.message}`);
            } // Update the unresolved inline comments count
            addUnresolvedInlineComment(annotationId, pageMode); // For experiment cohort, we pass the mutation data to onCreate
            // The experiment success and data load completion will be handled in AnnotationsContext
            // after the view component renders the new data
            const newComment = {
                // (Need to coerce the data from the new Comments Data Manager's mutation because it is
                // defined using the new Relay-generated types that define option fields as "| null | undefined"
                // but the original Apollo-generated types define them as just "| null".  These aren't compatible
                // without the coercion even though the "if (value)" or "value?." expressions would work the same.)
                ...data?.createInlineComment,
                isUnread: false,
                isOpen: true,
                type: (0, $8i27m.CommentType).INLINE,
                wasRemovedByAnotherUser: false,
                replies: [],
                reactionsSummary: null
            };
            addNewCommentThreads({
                general: {},
                inline: {
                    [annotationId]: newComment
                }
            }); // Create inline comment track event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: null,
                        isReply: false,
                        pageMode: pageMode,
                        isLivePage: createdFrom === 'LIVE',
                        navdexPointType: (0, $56QzY.END),
                        inlineNodeTypes: selectionOptions.inlineNodeTypes,
                        ...annotationElement && !isEditor && {
                            nodeType: $f4c77c6e390a7914$var$getNodeType(annotationElement, annotationId)
                        },
                        ...!isEditor && {
                            targetNodeType: targetNodeType
                        }
                    }
                }
            }).fire(); // Reset the editor
            onSuccess();
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                commentType: 'inline',
                entryPoint: 'create-comment',
                annotationId: annotationId
            }); /*
           * On editor pages, the view-inline-comment experience is started by the editor when the
           * created annotation is automatically selected after successful comment creation. For
           * editor pages, we update the attributes here to ensure that the experience is tracked
           * with the correct entry point.
           */ 
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_create')) {
                const attributes = {
                    annotationId: annotationId,
                    entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                    pageClass: pageClass
                };
                if (pageClass === 'renderer') experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        ...attributes
                    }
                });
                else if (pageClass === 'editor') experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
                if (isCommentsPanelShown) experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Comments panel is visible when it should not be'),
                    attributes: {
                        stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                    }
                });
            }
        };
        const onCreateFailure = (err)=>{
            saveAttemptedTracker.current.failedSaves = saveAttemptedTracker.current.failedSaves + 1;
            saveAttemptedCounts.current.failedSaves = saveAttemptedCounts.current.failedSaves + 1;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                error: err,
                attributes: {
                    pageId: pageId,
                    pageMode: pageMode,
                    isEditor: isEditor,
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                error: err,
                createAnalyticsEvent: createAnalyticsEvent,
                extraAttributes: {
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            if (!succeededPublish) saveAttemptedTracker.current.lastPublishFailure = err;
            let contentOutOfDate = false; // Get a truncated graphql error message
            const { errorId: errorId, message: message } = (0, $isdzP.parseError)(err);
            const translatedError = (0, $isdzP.getTranslatedError)(message); // COMMENTS-1879 - The backend will fall back to the old method of trying to make string matches if the content
            // is out of date. If the BE fails to apply a comment when using the old fallback method we should log it
            if ((0, $isdzP.isHighlightError)(translatedError)) {
                // Send the analytics event
                const analyticsObject = {
                    source: 'viewPage',
                    objectType: 'page',
                    objectId: pageId,
                    action: 'invalid',
                    actionSubject: 'highlight',
                    actionSubjectId: 'inlineComment',
                    attributes: {
                        errorMessage: message,
                        editor: 'FABRIC',
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        errorId: errorId,
                        highlightOrigin: 'userHighlight' // TODO: Do we need to programmatically track this?
                    }
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: analyticsObject
                }).fire();
                contentOutOfDate = true;
            }
            failPublishExperience(err, translatedError); // Use the existing value if it's already set or is an out of date error
            contentOutOfDate = contentOutOfDate || (0, $isdzP.isOutOfDateError)(translatedError); // In the case of an annotation error, we should show a flag to the user to let them know
            // their comment has been saved and they need to refresh the content (view mode only)
            if ((0, $isdzP.isAnnotationError)(translatedError)) {
                const CREATE_ERROR_FLAG_ID = `create-error-${Date.now()}`;
                flags.showWarningFlag({
                    id: CREATE_ERROR_FLAG_ID,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4c77c6e390a7914$var$i18n.unableToApplyTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError === (0, $9CnRS.i18n).unableToApplyAnnotation ? $f4c77c6e390a7914$var$i18n.unableToApplyDescription : translatedError),
                    actions: // Only show the refetch content action on view mode as it's not applicable in editor/live
                    pageMode === (0, $cD1qu.PageMode).VIEW ? [
                        {
                            content: formatMessage($f4c77c6e390a7914$var$i18n.refreshContentLink),
                            onClick: ()=>{
                                setRefetchContent(true);
                                handleOnClose();
                                flags.hideFlag(CREATE_ERROR_FLAG_ID);
                            }
                        }
                    ] : // TODO: Add actions for editor/live if needed
                    []
                }); // Log the occurance through analytics so we can still track it
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                        objectType: 'page',
                        objectId: pageId,
                        action: 'failed',
                        actionSubject: 'applyAnnotation',
                        actionSubjectId: 'inlineComment',
                        attributes: {
                            errorMessage: message,
                            editor: 'FABRIC',
                            framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            tenantId: cloudId,
                            userId: userId,
                            pageId: pageId
                        }
                    }
                }).fire();
                if ((0, $9wGTI.fg)('confluence_frontend_comment_highlight_apply_fixes')) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.fail(new Error('Unable to apply annotation to document'), {
                    errorMessage: message,
                    ...errorId ? {
                        errorId: errorId
                    } : {},
                    pageMode: pageMode,
                    context: isEditor ? 'editor' : 'renderer',
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                    pageId: pageId
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document'
                });
                onClose && onClose();
                return;
            } // CommentEditor expects a translated error message otherwise it fails
            // TODO: CommentEditor should likely just receive the translated message
            // rather than expect the object needed for FormattedMessage
            return Promise.reject({
                error: contentOutOfDate ? (0, $9CnRS.i18n).contentOutOfDate : translatedError,
                contentOutOfDate: contentOutOfDate
            });
        };
        // Wrap the createCommentFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const commentCreationInteropWrapper = (options)=>createInlineCommentInterop({
                originalMutationFn: createCommentFn,
                options: options,
                onCacheUpdateError: onCacheUpdateError
            });
        if ((0, $9wGTI.fg)('confluence_frontend_add_inline_comment_timeout')) return handleSaveCommentWithTimeout($f4c77c6e390a7914$export$d26c1daa0321174b, commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure));
        else return commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure);
    };
    const handleOnClose = (0, $42omo.useCallback)((hasContentChanged)=>{
        const reason = hasContentChanged ? 'comment discarded by user' : 'empty comment discarded by user';
        experienceTracker.abort({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            reason: reason
        }); // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', 'create');
        onClose && onClose();
    }, [
        experienceTracker,
        isEditor,
        onClose
    ]);
    const onEditorLoad = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
        const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191();
        if (!draftAnnotationElement && !wasDraftAnnotationRemoved) {
            // We have handling to show a message when we detect the draft annotation was removed, indicated by
            // `wasDraftAnnotationRemoved=true`. So we only need to fail the experience if we unexpectedly cannot find
            // the draftAnnotationElement, indicated by `wasDraftAnnotationRemoved=false`
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('No annotation element'));
            return;
        }
        setTimeout(()=>{
            // There are multiple useEffects involved in positioning the comment UI.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                // In the Editor and Renderer, the comment UI is positioned relative to slightly different
                // elements.
                if (!draftAnnotationElement) {
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                        abortReason: 'Draft annotation removed from document'
                    });
                    return;
                } else if (!sidebarEl.current) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Missing create comment ui'));
                else {
                    const commentUIVerticalDistanceFromAnnotation = Math.abs(draftAnnotationElement.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top); // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                    if (commentUIVerticalDistanceFromAnnotation > 40) {
                        const isVisible = sidebarEl.current.checkVisibility();
                        if (isVisible) {
                            // if it's fully visible, but misaligned, we don't treat this as a failure
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debug({
                                error: new Error('View Created Comment UI too far from annotation'),
                                createAnalyticsEvent: createAnalyticsEvent,
                                extraAttributes: {
                                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                                }
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                        } else {
                            (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                                misalignedBy: commentUIVerticalDistanceFromAnnotation
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Draft Comment UI is setup too far from annotation'));
                        }
                    } else (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                }
            });
        }, 1000);
    };
    if (loading || error) {
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog ${loading ? 'loading' : 'error'}`, {
            error: error?.message ?? '',
            loading: loading
        });
        return null;
    }
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        pageId: pageId,
        onClose: handleOnClose,
        isEditor: isEditor,
        annotationElement: annotationElement,
        sidebarOffset: sidebarOffset,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        isSticky: isSticky,
        isFabricPage: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$Container, {
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "create",
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor // @ts-ignore FIXME: `pageId` can be `undefined` here, and needs proper handling
    ), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        commentMode: "create",
        commentType: isEditor ? 'edit-inline' : 'inline',
        onEditorReady: onEditorLoad,
        hideWatchCheckbox: true,
        pageMode: isEditor ? 'edit' : 'view',
        shouldWarnOnInternalNavigation: true,
        useNewWarningModal: true,
        setShouldRefetch: ()=>setShouldRefetch(true),
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        wasDraftAnnotationRemoved: wasDraftAnnotationRemoved,
        isStandaloneComment: true,
        isOffline: isOffline
    })));
};
const $f4c77c6e390a7914$export$b217475cf0d7b767 = (0, $7aRa9.withFlags)($f4c77c6e390a7914$var$CreateCommentComponent); /**
                                                                 *
                                                                 * Exported for testing purposes only
                                                                 *
                                                                 * This function is used to find the draft annotation element in the DOM.
                                                                 * It checks both the renderer and editor for the draft annotation element.
                                                                 *
                                                                 * In some scenarios, there are duplicate draft annotations in the DOM such
                                                                 * as in the renderer where the dom for table headers is repeated.
                                                                 *
                                                                 * To mitigate this, we get all possible draft annotation elements and
                                                                 * and return the first one that has a height greater than 0.
                                                                 *
                                                                 * If no draft annotation element is found, it returns null.
                                                                 */ 
function $f4c77c6e390a7914$export$292a5d148db8f191() {
    const possibleAnnotations = document.querySelectorAll('[data-annotation-draft-mark="true"], .ak-editor-annotation-draft');
    if (possibleAnnotations.length === 1) // In cases where there is only one draft annotation, we can return it directly
    // and avoid the performance hit where reflow is triggered by checking if the
    // annotation has a height greater than 0.
    return possibleAnnotations[0];
    for(let i = 0; i < possibleAnnotations.length; i++){
        if (possibleAnnotations[i].getBoundingClientRect().height > 0) return possibleAnnotations[i];
    }
    return null;
}
module.exports["CreateComment"] = $f4c77c6e390a7914$export$b217475cf0d7b767;

});

parcelRegister("6cWI7", function(module, exports) {

var $l4jQJ = parcelRequire("l4jQJ");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment. Because the new Comments
// Data Manager caches all the data for comments in Relay, we need to define the mutation here so
// that the cache can be updated fully when a new comment is created - and that means the mutation
// needs to return the full comment data structure that we are using in the returned query part of
// the mutation.  Since that returned query is quite large, we define it here in its own hook to
// avoid having it in many places in the codebase - which makes the code harder to read and could
// lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// (Note that there is another exported GraphQL mutation variable named "CreateInlineCommentMutation"
// that is exported from @confluence/inline-comments-queries. It's okay that these are the same
// variable name because the other one does not seem to be imported anywhere in the codebase at
// present, this variable is only used internally in this file, and the actual muation's name -
// useCreateInlineCommentMutation - is unique so GQL won't complain.)
const $03f1ee89907a0c1d$var$CreateInlineCommentMutation = (0, $l4jQJ.default);
const $03f1ee89907a0c1d$export$10606ca3587bb707 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineCommentFn] = (0, $308Wd.useMutationInterop)($03f1ee89907a0c1d$var$CreateInlineCommentMutation);
    const addEmptyInlineRepliesArray = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: []
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comments. It will either call the new Comments Data Manager path or the old Apollo
    // mutation path depending on whether the relevant experiment is enabled.
    const createInlineCommentInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Strip out the old update function and other options, and adjust variables as needed
            // The includeReactionsAndReplies variable is needed by some of the legacy mutations but is
            // not needed by the new Comments Data Manager. So remove it if we're using the new path -
            // otherwise Typescript will complain and GQL may error as well.
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables ?? {
                includeReactionsAndReplies: undefined
            };
            const updateNewCommentInCache = (_dataProxy, mutationResult)=>{
                addCommentInCache({
                    newComment: addEmptyInlineRepliesArray(mutationResult.data.createInlineComment),
                    onError: onCacheUpdateError
                });
            };
            return createInlineCommentFn({
                variables: {
                    ...newVariables
                },
                update: updateNewCommentInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesArray,
        createInlineCommentFn
    ]);
    return {
        createInlineCommentInterop: createInlineCommentInterop
    };
};
module.exports["useCreateInlineCommentMutation"] = $03f1ee89907a0c1d$export$10606ca3587bb707;

});

parcelRegister("l4jQJ", function(module, exports) {
/**
 * @generated SignedSource<<9167f2621e6cf106559738ba6aef7b0e>>
 * @relayHash e24366c26db43cec71d2389d47713237
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885
const $3dcbd79e6f23278f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v9 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createInlineComment",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v7 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "childType",
                            "value": "comment"
                        },
                        {
                            "kind": "Literal",
                            "name": "contentType",
                            "value": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineCommentMutation",
            "selections": v12 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineCommentMutation",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e24366c26db43cec71d2389d47713237",
            "id": "6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885",
            "metadata": {},
            "name": "useCreateInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$3dcbd79e6f23278f$var$node.hash = "f3ea5340b40a0a0dd635fcfbf3e8ed68";
var $3dcbd79e6f23278f$export$2e2bcd8739ae039 = $3dcbd79e6f23278f$var$node;
module.exports["default"] = $3dcbd79e6f23278f$export$2e2bcd8739ae039;

});

parcelRegister("3Xfi8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7nPJ6 = parcelRequire("7nPJ6");


var $6HwWx = parcelRequire("6HwWx");

const $6a7e747c5d5174c7$export$9be7dcbe458ba189 = ({ annotationElement: annotationElement, isEditor: isEditor })=>{
    const classToCheck = '.pm-table-container';
    let elementToObserve = undefined;
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // elements to observe, these are different than elements that determine if the table is sticky
    if (isEditor) elementToObserve = isStickyHeaderExperimentEnabled ? annotationElement?.closest(classToCheck)?.querySelector('.pm-table-wrapper > table > tbody > tr') : annotationElement?.closest(classToCheck)?.parentElement?.querySelector('.pm-table-sticky-sentinel-top');
    else elementToObserve = annotationElement?.closest(classToCheck);
    const [isSticky, setIsSticky] = (0, $7nPJ6.useIsSticky)({
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    (0, $6HwWx.useStickyTableHeaderObserver)({
        setIsSticky: setIsSticky,
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    // Check if annotationElement is a child of tr (th element) and th's immediate parent is tbody
    const thElement = annotationElement?.closest('th');
    if (thElement) {
        const trElement = thElement.parentElement;
        const tbodyElement = trElement?.parentElement;
        // If tr is the first child of tbody, return false
        if (tbodyElement?.firstElementChild !== trElement) return {
            isSticky: false
        };
    }
    // if annotation element is inside a nested table, then return false
    if (annotationElement?.closest('.pm-table-nested-table-with-controls')) return {
        isSticky: false
    };
    // if annotation element is not inside a table header, then return false
    if (!annotationElement?.closest('th')) return {
        isSticky: false
    };
    // Remove debug console logs
    return {
        isSticky: isSticky
    };
};
module.exports["useShouldCommentSidebarBeSticky"] = $6a7e747c5d5174c7$export$9be7dcbe458ba189;

});

parcelRegister("7nPJ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jW2Ig = parcelRequire("jW2Ig");

const $b1509838bb0fcfff$export$2cf94d5875603a88 = ({ isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // check if table is already sticky
    const initialStickyState = elementToObserve ? (0, $jW2Ig.getIsSticky)(isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve.parentElement, isEditor) : false;
    const [isSticky, setIsSticky] = (0, $42omo.useState)((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState);
    // Sticky state effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    // Sticky state effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    return [
        isSticky,
        setIsSticky
    ];
};
module.exports["useIsSticky"] = $b1509838bb0fcfff$export$2cf94d5875603a88;

});

parcelRegister("jW2Ig", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $28177804efc2055d$export$17682ee29db08043 = (tableElement)=>{
    return Boolean(tableElement?.getAttribute('mode') === 'stick');
};
const $28177804efc2055d$export$4676b00e54210cb0 = (tableElement)=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    if (isStickyHeaderExperimentEnabled) return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
    return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};
const $28177804efc2055d$export$f3993a99776f75ca = (tableElement, isEditor)=>isEditor ? $28177804efc2055d$export$4676b00e54210cb0(tableElement) : $28177804efc2055d$export$17682ee29db08043(tableElement);
module.exports["isStickyInViewMode"] = $28177804efc2055d$export$17682ee29db08043;
module.exports["isStickyInEditMode"] = $28177804efc2055d$export$4676b00e54210cb0;
module.exports["getIsSticky"] = $28177804efc2055d$export$f3993a99776f75ca;

});

parcelRegister("6HwWx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jW2Ig = parcelRequire("jW2Ig");

const $cf08b287de1b8d82$export$204fd756b18b92ff = ({ setIsSticky: setIsSticky, isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // if the experiment is enabled and this is the editor, we need to observe the table element
    // else, we observe the parent element
    const stickyElementToObserve = isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve?.parentElement;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        // Create mutation observer to track class changes
        const stickyTableHeaderObserver = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (isEditor && (0, $jW2Ig.isStickyInEditMode)(target) || (0, $jW2Ig.isStickyInViewMode)(target)) setIsSticky(true);
                    else setIsSticky(false);
                }
            });
        });
        // Start observing class changes
        if (stickyElementToObserve) stickyTableHeaderObserver.observe(stickyElementToObserve, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        // Clean up all observers
        return ()=>{
            stickyTableHeaderObserver.disconnect();
        };
    }, [
        stickyElementToObserve,
        isEditor,
        setIsSticky
    ]);
};
module.exports["useStickyTableHeaderObserver"] = $cf08b287de1b8d82$export$204fd756b18b92ff;

});

parcelRegister("eA7s6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aHcFH = parcelRequire("aHcFH");

const $168172ede45a02b4$export$aca484f2c8185777 = ({ annotationElement: annotationElement, isEditor: isEditor, isViewCommentMode: isViewCommentMode, windowWidth: windowWidth, isSticky: isSticky })=>{
    return (0, $42omo.useMemo)(()=>{
        if (!annotationElement) return 0;
        if (isEditor) return (0, $aHcFH.calculateEditorOffsetFromParent)(annotationElement, '.fabric-editor-popup-scroll-parent');
        return (0, $aHcFH.calculateRendererOffsetFromParent)(annotationElement, `[data-annotation-draft-mark="true"]`, Boolean(isViewCommentMode));
    // We want to re-calculate when the window width changes or the comment sidebar becomes sticky / unsticky
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        annotationElement,
        isViewCommentMode,
        windowWidth,
        isSticky
    ]);
};
module.exports["useCommentSidebarOffset"] = $168172ede45a02b4$export$aca484f2c8185777;

});

parcelRegister("a3q17", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("B3Avz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $lisKW = parcelRequire("lisKW");


var $T1bCI = parcelRequire("T1bCI");


var $hmuev = parcelRequire("hmuev");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $hnvzE = parcelRequire("hnvzE");


var $3gadb = parcelRequire("3gadb");


var $6mKj3 = parcelRequire("6mKj3");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $eToX6 = parcelRequire("eToX6");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $3D12W = parcelRequire("3D12W");


var $3mVfX = parcelRequire("3mVfX");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $666Tc = parcelRequire("666Tc");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $8uM2K = parcelRequire("8uM2K");


var $6wiaZ = parcelRequire("6wiaZ");


var $bEwJH = parcelRequire("bEwJH");


var $bXQxx = parcelRequire("bXQxx");

const $2cc0402d98a7d80d$export$b8454eaf88df51d0 = (entry, setIsSticky, setSidebarOffset, sidebarOffset)=>{
    if (entry.intersectionRatio === 0) {
        setIsSticky(false);
        setSidebarOffset(sidebarOffset);
    } else {
        setIsSticky(true);
        setSidebarOffset((0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW));
    }
};
const $2cc0402d98a7d80d$var$redesignedViewAllStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.500',
    // This gives us 4px between the X and the comment icon
    top: 'space.150' // This lines us up exactly with X
});
const $2cc0402d98a7d80d$var$viewAllContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.075',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2cc0402d98a7d80d$var$commentHeaderStyle = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    display: 'flex',
    marginTop: 'space.400'
});
const $2cc0402d98a7d80d$var$commentNewHeaderMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.500'
});
const $2cc0402d98a7d80d$var$shadowElementStyle = {
    height: '4px',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0%, transparent 100%)',
    width: '100%',
    margin: '0',
    padding: '0'
};
const $2cc0402d98a7d80d$var$commentEditorStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeight = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeightAndScroll = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'scroll'
});
const $2cc0402d98a7d80d$var$boxWithoutMaxHeight = (0, $ecnYn.xcss)({
    overflowY: 'visible'
});
const $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto = (0, $ecnYn.xcss)({
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightScroll = (0, $ecnYn.xcss)({
    overflowY: 'scroll'
});
const $2cc0402d98a7d80d$export$d560bdb1ceec916a = ({ pageId: pageId, onClose: onClose, annotationElement: annotationElement, navigationOptions: navigationOptions, isEditor: isEditor, isViewCommentMode: isViewCommentMode, children: children, sidebarOffset: sidebarOffset, commentId: commentId, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, sidebarEl: sidebarEl, annotationId: annotationId, inlineCommentRef: inlineCommentRef = ()=>{}, nudgeRef: nudgeRef, isSticky: isSticky, isFabricPage: isFabricPage, authorName: authorName, setPopupsScrollableElement: setPopupsScrollableElement, onMaxHeightApplied: onMaxHeightApplied })=>{
    const [oldIsSticky, setOldIsSticky] = (0, $42omo.useState)(false);
    const [newSidebarOffset, setSidebarOffset] = (0, $42omo.useState)(sidebarOffset);
    const [showA11yAnnouncement, setShowA11yAnnouncement] = (0, $42omo.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    const [isRefSet, setIsRefSet] = (0, $42omo.useState)(false);
    // Compute isMaxHeightEnabledForSticky first to pass to hook
    const isMaxHeightEnabledForSticky = (0, $6mKj3.expValEquals)('confluence_comment_enable_maxheight', 'isEnabled', true) || isSticky && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix');
    // Compute hasMaxHeight locally and notify parent via callback
    const { hasMaxHeight: hasMaxHeight, dynamicMaxHeight: dynamicMaxHeight } = (0, $6wiaZ.useHasMaxHeight)({
        sidebarEl: sidebarEl,
        isRefSet: isRefSet,
        isFabricPage: isFabricPage,
        isSticky: isSticky,
        annotationElement: annotationElement,
        isEditor: isEditor,
        sidebarOffset: sidebarOffset,
        isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky
    });
    const applyMaxHeightStyles = hasMaxHeight && isMaxHeightEnabledForSticky;
    const useDynamicMaxHeight = !!dynamicMaxHeight && (0, $6mKj3.expValEquals)('cc_comments_dynamic_inline_height', 'isEnabled', true);
    // Notify parent when max height styles change
    (0, $42omo.useEffect)(()=>{
        onMaxHeightApplied?.(!!applyMaxHeightStyles);
    }, [
        applyMaxHeightStyles,
        onMaxHeightApplied
    ]);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        let offset = 0;
        if (annotationElement && !isEditor) {
            let scrollParent;
            if (isEditor) {
                scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
                offset = (0, $aHcFH.calculateElementOffset)(annotationElement, scrollParent);
            } else {
                /*
        There's two cases here: a view comment and a create comment.
        We need the correct scrollParent for each case.
        Since it's not the editor in this logical branch we should use #content as the scrollParent.
        */ scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
                if (scrollParent) {
                    let annotationOffset = 0;
                    if (isViewCommentMode) // If the sidebar is rendering a view comment, we can use the annotationElement directly.
                    annotationOffset = (0, $aHcFH.calculateElementOffset)(annotationElement);
                    else {
                        /*
            If the sidebar is rendering a create comment the annotationElement is actually the wrapperDOM
            we need to find the actual highlight instead. We can find this by looking for the mark because
            there will always be a mark before the create comment button is clicked.
            */ const actualHiglightElement = scrollParent.querySelector(`[data-annotation-draft-mark="true"]`);
                        annotationOffset = (0, $aHcFH.calculateElementOffset)(actualHiglightElement, undefined, true);
                    }
                    offset = annotationOffset + scrollParent.offsetTop;
                }
            }
            setSidebarOffset(offset);
        }
    }, [
        annotationElement,
        isEditor,
        isViewCommentMode
    ]);
    (0, $42omo.useEffect)(()=>{
        // handles media comment scroll
        if (isRefSet && sidebarEl.current && isEditor) {
            if (isOpeningMediaCommentFromToolbar && annotationElement) (0, $i49vP.scrollToElementInEditor)({
                targetElement: annotationElement,
                viewingRoomOffset: -150
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        annotationElement,
        isOpeningMediaCommentFromToolbar,
        commentId,
        isViewCommentMode,
        isEditor
    ]);
    (0, $42omo.useEffect)(()=>{
        let mouseTrap;
        let focusTrap;
        if (isRefSet && sidebarEl.current) {
            mouseTrap = new (0, (/*@__PURE__*/$parcel$interopDefault($lisKW)))(sidebarEl.current);
            // prevent saving via mod+enter from also publishing the page in edit mode
            mouseTrap.bind((0, $gnkil.INLINE_COMMENTS_SHORTCUT), (event)=>{
                event.stopPropagation();
            });
            if (!showA11yAnnouncement) // We need to show this on a timer so the `aria-live` listener will respond with our message
            setTimeout(()=>{
                setShowA11yAnnouncement(true);
            }, 100);
        }
        return ()=>{
            if (mouseTrap) mouseTrap.reset();
            if (focusTrap) focusTrap.deactivate();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet
    ]);
    const handlePropagation = (event)=>{
        /**
     * prevents an event bubbling up to removing focus
     * from the highlight displaying the sidebar
     */ event.stopPropagation();
    };
    const handleOpeningCommentsPanel = (0, $42omo.useCallback)(()=>{
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        if (annotationId) {
            setCurrentlySelectedThreadKey(annotationId);
            (0, $9FoVw.handleCommentsPanelNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentId: commentId,
                commentType: 'INLINE',
                annotationClicked: true
            });
        }
    }, [
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        annotationId,
        commentId
    ]);
    const handleOnClose = (0, $42omo.useCallback)((dialogs, isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(hasContentChanged);
    }, [
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const handleViewAllClick = (0, $42omo.useCallback)((dialogs)=>{
        handleOnClose(dialogs, true);
    }, [
        handleOnClose
    ]);
    const handleScroll = (0, $42omo.useCallback)((event)=>{
        if (!(0, $9wGTI.fg)('confluence_comment_header_margin')) return;
        const target = event.currentTarget;
        // Check if the inline-comment-sidebar-wrapper is scrolled
        const scrolled = target.scrollTop > 0;
        setIsScrolled(scrolled);
    }, []);
    const sidebarId = (0, $aHcFH.getSidebarId)(isEditor, isViewCommentMode);
    const mode = isEditor ? 'edit' : 'view';
    const intl = (0, $8C5kA.default)();
    const closeCommentBox = intl.formatMessage((0, $bEwJH.i18n).closeCommentBox);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const sidebarBoundingRect = sidebarEl.current?.getBoundingClientRect();
    const isSidebarExtendedBeyondViewport = (sidebarBoundingRect?.bottom ?? 0) > window.innerHeight;
    /**
   * useEffect to handle sticky comment behavior when attached to a sticky table header.
   * As the user scrolls, the IntersectionObserver triggers the callback the moment the table header starts/stops being sticky
   */ (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
            const stickyHeader = annotationElement?.closest('.pm-table-sticky-wrapper');
            if (stickyHeader && !isSidebarExtendedBeyondViewport) {
                // eslint-disable-next-line no-restricted-syntax
                const observer = new IntersectionObserver(([entry])=>$2cc0402d98a7d80d$export$b8454eaf88df51d0(entry, setOldIsSticky, setSidebarOffset, sidebarOffset), {
                    threshold: 1.0
                });
                observer.observe(stickyHeader);
                return ()=>observer.disconnect();
            }
        }
    }, [
        annotationElement,
        sidebarOffset,
        sidebarEl,
        isSidebarExtendedBeyondViewport
    ]);
    const commentSidebarIsSticky = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? isSticky : oldIsSticky;
    const commentResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_comment_enable_preview_panel_support') ? (0, $eToX6.isInPreviewPanel)() : false;
    const viewAllResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_previewpanel_enable_comments_panel') ? (0, $eToX6.isInPreviewPanel)() : false;
    /**
   * Below logic to set rightOffset is temporary fix.
   * It is very fragile as there are many conditions in ObjectSidebarControl
   * 	component to show/hide action bar and rovo button.
   * Also values are hardcoded.
   */ let rightOffset = 0;
    if (mode === 'view' && isObjectSidebarShown) /**
     * Need rightOffset only when container size doesn't change when
     * 	action bar panel (e.g details panel, comments panel).
     * That happens currently only in view page.
     */ rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH);
    else if (/**
   * When action bar or rovo button is shown, need to set rightOffset,
   * 	otherwise long comment sidebar overlaps on it.
   */ !isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) /**
     * Width of action bar is 48px,
     * 	got it from object-sidebar-components/src/ObjectSidebarControl.tsx.
     * This is not ideal solution, as it is hardcoded.
     * check if previewPanel support is enabled
     */ {
        if (!commentResidesInPreviewPanel) {
            // es-lint-disable-next-line confluence-feature-gating/no-preconditioning
            if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
                rightOffset = 100; // add more offset from the right edge of the page so it doesn't overlap with the object sidebar
                if (mode === 'view') rightOffset += commentSidebarIsSticky ? 67 : 12;
                else rightOffset += commentSidebarIsSticky ? 27 : 12;
            } else rightOffset = 48 + (commentSidebarIsSticky ? 52 : 12);
        }
    }
    const a11yProps = (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
        role: 'dialog',
        'aria-modal': false,
        'aria-label': intl.formatMessage((0, $bEwJH.i18n).commentSidebarLabel, {
            name: authorName || ''
        })
    } : {};
    const sidebarContainerOffset = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? commentSidebarIsSticky ? isEditor ? sidebarOffset : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : sidebarOffset : newSidebarOffset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: pageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "comment-sidebar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.SidebarContainer), {
            offset: sidebarContainerOffset,
            rightOffset: rightOffset,
            isSticky: commentSidebarIsSticky,
            onClick: handlePropagation,
            id: sidebarId,
            "data-testid": sidebarId,
            "data-cy": sidebarId,
            mode: mode,
            ref: (el)=>{
                sidebarEl.current = el;
                if (nudgeRef) nudgeRef.current = el;
                setIsRefSet(true);
                inlineCommentRef(el);
            },
            ...a11yProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.TopContainer), {
            showNavigation: Boolean(navigationOptions)
        }, annotationId && (0, $9wGTI.fg)('confluence-frontend-comments-panel') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $2cc0402d98a7d80d$var$viewAllContainerStyles,
            testId: "view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: ()=>handleViewAllClick(dialogs),
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    ...iconProps,
                    label: "Comment Icon",
                    color: "var(--ds-icon-subtle)"
                }),
            appearance: "subtle",
            spacing: "compact",
            testId: "comment-sidebar-viewall-button",
            interactionName: "view-comments-menu-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtle"
        }, intl.formatMessage((0, $bEwJH.i18n).viewAllCommentsButtonText)))), navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick,
            disableCommentCount: navigationOptions.disableCommentCount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /**
                 * confluence_frontend_content_wrapper hides inline comment button
                 * confluence-frontend-comments-panel enables comments panel
                 * When either one of the feature gate is enabled, the toggle inline comments shortcut would not work
                 */ (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
                isEditorShortcut: isEditor && !isLiveViewMode,
                contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
                isTooltip: true
            }),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            isUpdatedStandaloneComment: false,
            onClick: ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: closeCommentBox,
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            })
        })))), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $2cc0402d98a7d80d$var$commentHeaderStyle,
                (0, $9wGTI.fg)('confluence_comment_header_margin') && $2cc0402d98a7d80d$var$commentNewHeaderMargin,
                !isViewCommentMode && $2cc0402d98a7d80d$var$commentEditorStyle
            ]
        }, navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick,
            disableCommentCount: navigationOptions.disableCommentCount
        }), annotationId && !viewAllResidesInPreviewPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            testId: "redesigned-view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2cc0402d98a7d80d$var$redesignedViewAllStyle,
            onClick: (e)=>{
                e.stopPropagation();
                handleViewAllClick(dialogs);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D12W.CommentPanelButton), {
            contentId: pageId,
            testId: "standalone-comment-view-all-button",
            isStandaloneComment: true,
            isViewAllIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            onClick: ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: intl.formatMessage((0, $bEwJH.i18n).closeInlineCommentThread),
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            }),
            isUpdatedStandaloneComment: true
        })))), isScrolled && (0, $9wGTI.fg)('confluence_comment_header_margin') && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: $2cc0402d98a7d80d$var$shadowElementStyle
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "inline-comment-sidebar-wrapper",
            ref: (el)=>{
                if (applyMaxHeightStyles) setPopupsScrollableElement?.(el);
            },
            xcss: [
                applyMaxHeightStyles && !useDynamicMaxHeight && (0, $6mKj3.expValEquals)('confluence_frontend_fix_no_unnecessary_scrollbar', 'isEnabled', true) && $2cc0402d98a7d80d$var$boxWithMaxHeight,
                applyMaxHeightStyles && !useDynamicMaxHeight && !(0, $6mKj3.expValEquals)('confluence_frontend_fix_no_unnecessary_scrollbar', 'isEnabled', true) && $2cc0402d98a7d80d$var$boxWithMaxHeightAndScroll,
                applyMaxHeightStyles && useDynamicMaxHeight && (0, $6mKj3.expValEquals)('confluence_frontend_fix_no_unnecessary_scrollbar', 'isEnabled', true) && $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto,
                applyMaxHeightStyles && useDynamicMaxHeight && !(0, $6mKj3.expValEquals)('confluence_frontend_fix_no_unnecessary_scrollbar', 'isEnabled', true) && $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightScroll,
                !applyMaxHeightStyles && $2cc0402d98a7d80d$var$boxWithoutMaxHeight
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: // xcss only supports static styles
            applyMaxHeightStyles && useDynamicMaxHeight ? {
                maxHeight: dynamicMaxHeight
            } : undefined,
            onScroll: handleScroll
        }, children))))));
};
module.exports["CommentSidebar"] = $2cc0402d98a7d80d$export$d560bdb1ceec916a;

});

parcelRegister("6wiaZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $781ef84c6c89584f$export$d1fb14f3b5498c7a = ({ sidebarEl: sidebarEl, isRefSet: isRefSet, isSticky: isSticky, isFabricPage: isFabricPage, annotationElement: annotationElement, isEditor: isEditor, sidebarOffset: sidebarOffset, isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky })=>{
    const [hasMaxHeight, setHasMaxHeight] = (0, $42omo.useState)(false);
    const [dynamicMaxHeight, setDynamicMaxHeight] = (0, $42omo.useState)(undefined);
    // Shared max height check logic
    const checkMaxHeight = (0, $42omo.useCallback)(()=>{
        // Check if annotation is in a sticky table header & on edit mode
        if (annotationElement && isEditor && isMaxHeightEnabledForSticky && (0, $6mKj3.expValEquals)('cc_comments_dynamic_inline_height', 'isEnabled', true)) {
            const stickyTable = annotationElement.closest('table.pm-table-sticky');
            const inStickyTableHeader = Boolean(stickyTable);
            // Special case: annotation in sticky table header - calculate max height based on where sidebar will be positioned
            // Without this check, long comment threads can sometimes have their bottom permanently below the viewport on small-width pages
            if (inStickyTableHeader && isSticky) {
                const annotationRect = annotationElement.getBoundingClientRect();
                const annotationBottom = annotationRect.bottom;
                // Use the sidebar offset that will be applied (STICKY_COMMENT_VERTICAL_OFFSET_VIEW for view, or sidebarOffset for editor)
                const offset = sidebarOffset ?? 0;
                const sidebarTop = annotationBottom + offset;
                const viewportHeight = window.innerHeight;
                // Calculate max height as distance from where sidebar top will be to bottom of viewport
                const calculatedMaxHeight = viewportHeight - sidebarTop;
                // Only apply if the calculated max height is positive and would actually constrain the sidebar
                // Otherwise, continue to default behavior
                if (calculatedMaxHeight > 0) {
                    setDynamicMaxHeight(`${calculatedMaxHeight}px`);
                    setHasMaxHeight(true);
                    return;
                }
            }
        }
        // Default (i.e. non-special-cate) behavior
        if (!sidebarEl.current) return;
        if (isSticky) {
            setHasMaxHeight(true);
            setDynamicMaxHeight(undefined);
            return;
        }
        const rect = sidebarEl.current.getBoundingClientRect();
        const availableHeight = window.innerHeight - 300;
        setHasMaxHeight(rect.height > availableHeight);
        setDynamicMaxHeight(undefined);
    }, [
        isSticky,
        sidebarEl,
        annotationElement,
        isEditor,
        sidebarOffset,
        isMaxHeightEnabledForSticky
    ]);
    // Max height effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    // Max height effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    return {
        hasMaxHeight: hasMaxHeight,
        dynamicMaxHeight: dynamicMaxHeight
    };
};
module.exports["useHasMaxHeight"] = $781ef84c6c89584f$export$d1fb14f3b5498c7a;

});

parcelRegister("bEwJH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6015f360c209854c$export$fafb84dd8a714e7a = 5;
const $6015f360c209854c$export$6882b33952f7e4d2 = 125;
const $6015f360c209854c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    closeCommentBox: {
        id: "annotation-provider-inline-comments.closeCommentBox",
        defaultMessage: "Close inline comments"
    },
    closeInlineCommentThread: {
        id: "annotation-provider-inline-comments.close.InlineCommentThread",
        defaultMessage: "Close inline comment thread"
    },
    closeSidebarTooltip: {
        id: "annotation-provider-inline-comments.close.icon.tooltip",
        defaultMessage: "Close comment"
    },
    viewAllCommentsButtonText: {
        id: "annotation-provider-inline-comments.view-all.button.text",
        defaultMessage: "View all"
    },
    commentSidebarLabel: {
        id: "annotation-provider-inline-comments.comment.sidebar.label",
        defaultMessage: "Inline comment by {name}"
    },
    commentSidebarAnnouncement: {
        id: "annotation-provider-inline-comments.comment.sidebar.announcement",
        defaultMessage: "Comment sidebar shown, use Shift + Tab to reach the comment sidebar"
    }
});
module.exports["MAX_UNCOLLAPSED_REPIES"] = $6015f360c209854c$export$fafb84dd8a714e7a;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW"] = $6015f360c209854c$export$6882b33952f7e4d2;
module.exports["i18n"] = $6015f360c209854c$export$a7357cdd1f0b0168;

});

parcelRegister("bXQxx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $7N1sB = parcelRequire("7N1sB");


var $9wGTI = parcelRequire("9wGTI");


var $cZa7r = parcelRequire("cZa7r");


var $3BCCf = parcelRequire("3BCCf");

const $d6eff27ff915f22d$var$positionRightStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    right: 'space.800'
});
const $d6eff27ff915f22d$var$positionLeftStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.150'
});
const $d6eff27ff915f22d$export$c7f093fedf3e73fe = ({ pageId: pageId, commentData: commentData, isEditor: isEditor, onNavigationClick: onNavigationClick, disableCommentCount: disableCommentCount })=>{
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { currentCommentIndex: currentCommentIndex, goToNextInlineComment: originalGoToNext, goToPrevInlineComment: originalGoToPrev, commentsCount: commentsCount } = (0, $3BCCf.useInlineCommentNavigation)({
        isEditor: isEditor,
        pageId: pageId,
        onNavigationClick: onNavigationClick,
        commentData: commentData
    });
    // Wrap navigation functions to clear stored comment data before navigation
    const goToNextInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToNext();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToNext
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToPrev();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToPrev
    ]);
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: [
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (0, $9wGTI.fg)('confluence-frontend-comments-panel') && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionRightStyles,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || !(0, $9wGTI.fg)('confluence-frontend-comments-panel')) && $d6eff27ff915f22d$var$positionLeftStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            currentCommentIndex: currentCommentIndex,
            commentsCount: commentsCount,
            disableCommentCount: disableCommentCount
        })), [
        commentsCount,
        currentCommentIndex,
        goToNextInlineComment,
        goToPrevInlineComment,
        disableCommentCount
    ]);
};
module.exports["CommentNavigation"] = $d6eff27ff915f22d$export$c7f093fedf3e73fe;

});

parcelRegister("3BCCf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9jl6v = parcelRequire("9jl6v");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");

const $33dbfc40da2aecd4$export$248861b924bd617d = ({ pageId: pageId, isEditor: isEditor, onNavigationClick: onNavigationClick, commentData: commentData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations
    ]);
    const currentInlineMarkerRef = commentData?.location?.inlineMarkerRef ?? '';
    const currentCommentIndex = getCommentIndex(currentInlineMarkerRef);
    const goToNextInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'next',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'previous',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            currentCommentIndex: currentCommentIndex,
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            commentsCount: orderedActiveAnnotations.length
        }), [
        goToNextInlineComment,
        goToPrevInlineComment,
        orderedActiveAnnotations.length,
        currentCommentIndex
    ]);
};
module.exports["useInlineCommentNavigation"] = $33dbfc40da2aecd4$export$248861b924bd617d;

});


//# sourceMappingURL=CommentsPanelFilterMenu.6043e3ac.js.map
